import createGetFormAsyncErrors from './selectors/getFormAsyncErrors';
import plain from './structure/plain';

export default createGetFormAsyncErrors(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/getFormAsyncErrors.js
// module id = 532
// module chunks = 0